import React, { useCallback, useEffect, useState } from 'react';
import { FaStar } from 'react-icons/fa';
import { CiLocationOn } from "react-icons/ci";
import { Stay } from '../../types';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '../../store';
import { addFavorite, deleteFavorite } from '../../features/home/favSlice';
import { PiHeartDuotone, PiHeartFill } from 'react-icons/pi';
import { Link } from 'react-router-dom';

const StayCard = ({ stay,userId }: { stay: Stay ,userId:string | number | undefined }) => {
    const dispatch = useDispatch<AppDispatch>();
    const [isFavorite, setIsFavorite] = useState(stay.isFavorite);
   

    useEffect(() => {
        setIsFavorite(stay.isFavorite);
    }, [stay.isFavorite]);

  const handleAddToFavorite = useCallback(
     (e: React.MouseEvent) => {
      e.preventDefault();
      e.stopPropagation();

      if (!userId) return alert("User not logged in");

      dispatch(addFavorite({
        itemId: stay.id,
        userId,
        type: "Place",
      }));
    },
    [dispatch, stay.id, userId]
  );

  const handleRemoveFromFavorite = useCallback(
    (e: React.MouseEvent) => {
      e.preventDefault();
      e.stopPropagation();

      if (!userId) return;

      dispatch(deleteFavorite({
        itemId: stay.id,
        userId,
        type: "Place",
      }));
    },
    [dispatch, stay.id, userId]
  );

    return (
        <Link to={`/place/${stay?.id}`} className="p-2 overflow-hidden   bg-grayColor relative rounded-lg h-full flex flex-col gap-1">
            <div className="aspect-[4/3] w-full overflow-hidden rounded-lg">
                <img
                    className="w-full h-full object-cover"
                    src={stay.images[0]?.url}
                    alt="stay"
                    loading="lazy"
                />
            </div>
            <div className="flex justify-between items-start">
                <h3 className="font-semibold text-lg text-nowrap w-3/4 overflow-x-hidden text-ellipsis">{stay.title}</h3>
                <p className="flex items-center gap-1 text-secondry">
                    <FaStar className="text-sm" />
                    <span>{stay.rate}</span>
                </p>
            </div>
           
            <p className="text-sm text-textSecond line-clamp-2  min-h-[40px]">{stay.details}</p>
            <div className="flex justify-between text-nowrap text-sm pt-2 border-t border-textSecond border-dashed">
                <div className='flex'>
                    <p className="font-semibold text-secondry text-nowrap">{stay.price}</p>
                    <span className="text-xs text-textSecond"> {stay.type === "Hall" ? "/Hour" : "/ Night"} </span>
                </div>
                <div className="flex items-center justify-self-end gap-1">
                    <CiLocationOn className="text-lg text-secondry" />
                    <p className='text-nowrap'>{stay.location}</p>
                </div>
            </div>
            <div className="flex justify-between items-center mt-auto absolute w-full px-3 py-2 left-0">
                <p className="text-xs bg-primary text-white px-2 py-1 rounded">{stay.subCategory.title}</p>
                {userId ? isFavorite ? (
                    <button
                       onClick={handleRemoveFromFavorite}
                        className="text-red-600 text-lg hover:opacity-80 transition"
                    >
                        <PiHeartFill />
                    </button>
                ) : (
                    <button
                       onClick={handleAddToFavorite}
                        className="text-white text-lg hover:text-red-500 transition"
                    >
                        <PiHeartDuotone />
                    </button>
                ) : ""}
            </div>
        </Link>
    );
};

export default StayCard;
